/** Formato es-VE para la UI (§2.4: porcentaje 0.00%, símbolo $). */

const numFmt = new Intl.NumberFormat('es-VE', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const intFmt = new Intl.NumberFormat('es-VE', { maximumFractionDigits: 0 });

/** A percentage already expressed as 0..100 (the API multiplies fractions ×100). */
export function fmtPct(n: number | null | undefined): string {
  if (n == null) return '—';
  return `${numFmt.format(n)}%`;
}

export function fmtUsd(n: number | null | undefined): string {
  if (n == null) return '—';
  return `$${numFmt.format(n)}`;
}

export function fmtBs(n: number | null | undefined): string {
  if (n == null) return '—';
  return `Bs ${numFmt.format(n)}`;
}

export function fmtInt(n: number | null | undefined): string {
  if (n == null) return '—';
  return intFmt.format(n);
}

/** Format a delta percentage (fraction) with sign, for KPI cards. */
export function fmtDeltaPct(deltaPct: number | null | undefined): string {
  if (deltaPct == null) return '';
  const sign = deltaPct > 0 ? '+' : '';
  return `${sign}${numFmt.format(deltaPct * 100)}%`;
}

export function deltaTone(deltaPct: number | null | undefined): 'up' | 'down' | 'flat' {
  if (deltaPct == null || deltaPct === 0) return 'flat';
  return deltaPct > 0 ? 'up' : 'down';
}
